export function initSela() {
  document.documentElement.classList.add('sela')
}
